import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTranslation } from 'react-i18next';
import { whatsAppLink } from '../utils/whatsapp';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  /* Subscribe to language so the deep-link's prefilled greeting refreshes
     whenever the user switches locale. */
  const { i18n } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const _lang = i18n.language;
  const link = whatsAppLink();
  const label = 'Chat with us on WhatsApp';

  return (
    /* The Tooltip wraps the anchor, not the positioning Box. Wrapping the Box
       put `aria-label` on a plain <div>, which is a prohibited ARIA attribute
       (a div has no role to label) and left the link itself with no accessible
       name — it contains only an icon. Both were Lighthouse failures. */
    <Box
      sx={{
          position: 'fixed',
          /* Cleared above the bottom-anchored mobile header so it doesn't
             collide with the Reserve pill on small screens. */
          bottom: { xs: '6.25rem', md: '3rem' },
          right: { xs: '1.25rem', md: '2rem' },
          zIndex: 999,
        }}
      >
        <Tooltip title={label} arrow placement="left">
        <IconButton
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          sx={{
            width: { xs: '56px', md: '64px' },
            height: { xs: '56px', md: '64px' },
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #25D366 0%, #20BA5A 100%)',
            color: '#ffffff',
            boxShadow: isHovered
              ? '0 12px 40px rgba(37, 211, 102, 0.4)'
              : '0 8px 25px rgba(37, 211, 102, 0.3)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            /* Slow outward ring, borrowed from labeau_landing's whatsappPulse.
               Paused on hover so the ring doesn't fight the lift, and it only
               runs while idle — a permanent pulse next to a static page reads
               as a notification badge rather than an invitation. */
            animation: isHovered ? 'none' : 'ts-pulse 3.2s ease-out 2s infinite',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
              transform: 'scale(1.1) translateY(-4px)',
              boxShadow: '0 16px 50px rgba(37, 211, 102, 0.5)',
            },
            '& svg': {
              fontSize: { xs: '1.75rem', md: '2rem' },
            },
          }}
        >
          <WhatsAppIcon />
        </IconButton>
        </Tooltip>
      </Box>
  );
};

export default WhatsAppButton;
